import React, {useEffect, useState} from 'react';
import { collection, getDocs } from 'firebase/firestore';

import {
    ArrowPathIcon,
    EnvelopeIcon,
    EyeSlashIcon,
    GlobeAmericasIcon,
    IdentificationIcon,
    LockOpenIcon,
    MapIcon,
    MoonIcon,
    PhoneIcon,
    PrinterIcon,
    SunIcon,
    UserIcon,
} from "@heroicons/react/24/outline";
import {useAuth} from "../contexts/authContext";
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { doc, setDoc } from 'firebase/firestore';
import { storage, db } from '../firebase/firebase';
import {
    Button,
    Dialog,
    DialogBackdrop,
    DialogPanel, DialogTitle,
    Field,
    Input,
    Label,
    Select,
    Switch,
    Textarea
} from "@headlessui/react";
import {useDarkMode} from "../contexts/darkModeContext";
import {XMarkIcon, CheckBadgeIcon} from "@heroicons/react/16/solid";
import Loading from "./Widgets/Loading";
import {getAuth, sendPasswordResetEmail, updateEmail} from "firebase/auth";
import AccountCard from "./Profile/AccountCard";
import {
    accountLevelMapping,
    formatPhoneNumber,
    pricingMapping,
    stateMapping,
    supervisorMapping
} from "./GLOBAL/GlobalFunctions";
import {useNotification} from "./Notifications/NotificationProvider";
import TerrainSVG from "./Widgets/TerrainSVG";
import EmptySVG from "./Widgets/EmptySVG";
// import course from "../PFC_Images/PFCWarehouse.JPG";
import course from "../PFC_Images/course.jpg";
import CustomButton from "./Widgets/CustomButton";


const Profile = () => {

    const { currentUser } = useAuth();
    const { notificationsEnabled, toggleNotifications } = useNotification();
    const { triggerNotification } = useNotification();
    const { darkMode, toggleDarkMode } = useDarkMode();

    // eslint-disable-next-line no-unused-vars
    const [image, setImage] = useState(null); // To store the selected image file
    // eslint-disable-next-line no-unused-vars
    const [uploading, setUploading] = useState(false); // Upload status
    // eslint-disable-next-line no-unused-vars
    const [imageURL, setImageURL] = useState(''); // To store the uploaded image URL


    const [isPassword, setIsPassword] = useState(false);
    const [isEmail, setIsEmail] = useState(false);


    const [title, setTitle] = useState("");
    const [body, setBody] = useState("");
    




    const [fname, setFname] = useState("");
    const [lname, setLname] = useState("");
    const [fullname, setFullname] = useState("");
    const [salesCode, setSalesCode] = useState("");
    const [profileImage, setProfileImage] = useState('');
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [fax, setFax] = useState("");
    
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("")
    const [zip, setZip] = useState("");
    
    const [region, setRegion] = useState("");
    const [supervisor, setSupervisor] = useState("");
    const [accountLevel, setAccountLevel] = useState("");
    const [birthDate, setBirthDate] = useState("");
    

    const togglePassword = () => {
        setIsPassword(!isPassword);
    }

    const toggleEmail = () => {
        setIsEmail(!isEmail);
    }
    
    useEffect(() => {
        const fetchUserName = async () => {
            if (currentUser) {
                try {
                    // Check if user data is in localStorage
                    const storedUserData = localStorage.getItem(`userData_${currentUser.uid}`);

                    if (storedUserData) {
                        // Use the stored user data
                        const userData = JSON.parse(storedUserData);
                        setFname(userData.fname || "");
                        setLname(userData.lname || "");
                        setSalesCode(userData.salesCode || "");
                        setFullname(userData.fname + " " + userData.lname  || "");
                        setProfileImage(userData.profileImageUrl || "");
                        setEmail(userData.email || "");
                        setPhone(userData.phone || "");
                        setFax(userData.fax || "");
                        setAddress(userData.address || "");
                        setCity(userData.city || "");
                        setState(userData.state || "");
                        setZip(userData.zip || "");
                        setRegion(userData.region || "");
                        setSupervisor(userData.supervisor || "");
                        setAccountLevel(userData.accountLevel || "");
                        setSelectedReps(userData.reps || []);
                        setBirthDate(userData.birthDate || "");


                    } else {
                        // Fetch user document from Firestore based on the current user's UID
                        const userDoc = await db.collection('Users').doc(currentUser.uid).get();
                        if (userDoc.exists) {
                            // Get the user's name from the document data
                            const userData = userDoc.data();
                            setFname(userData.fname || "");
                            setLname(userData.lname || "");
                            setSalesCode(userData.salesCode || "");
                            setFullname(userData.fname + " " + userData.lname  || "");
                            setProfileImage(userData.profileImageUrl || "");
                            setEmail(userData.email || "");
                            setPhone(userData.phone || "");
                            setFax(userData.fax || "");
                            setAddress(userData.address || "");
                            setCity(userData.city || "");
                            setState(userData.state || "");
                            setZip(userData.zip || "");
                            setRegion(userData.region || "");
                            setSupervisor(userData.supervisor || "");
                            setAccountLevel(userData.accountLevel || "");
                            setSelectedReps(userData.reps || []);
                            setBirthDate(userData.birthDate || "");
                            

                            // Save user data to localStorage
                            localStorage.setItem(`userData_${currentUser.uid}`, JSON.stringify(userData));
                        } else {
                            console.log('User document not found');
                        }
                    }
                } catch (error) {
                    console.error('Error fetching user data:', error);
                }
            }
        };

        fetchUserName();
    }, [currentUser]);


    const [updating, setUpdating] = useState(false);

    
    const onUpdate = async () => {
        setUpdating(true);
        const startTime = Date.now();
        
        try {
            // Fetch user document from Firestore based on the current user's UID
            const userDoc = await db.collection('Users').doc(currentUser.uid).get();
            if (userDoc.exists) {
                // Get the user's name from the document data
                const userData = userDoc.data();
                setFname(userData.fname || "");
                setLname(userData.lname || "");
                setSalesCode(userData.salesCode || "");
                setFullname(userData.fname + " " + userData.lname  || "");
                setProfileImage(userData.profileImageUrl || "");
                setEmail(userData.email || "");
                setPhone(userData.phone || "");
                setFax(userData.fax || "");
                setAddress(userData.address || "");
                setRegion(userData.region || "");
                setSupervisor(userData.supervisor || "");
                setAccountLevel(userData.accountLevel || "");
                setSelectedReps(userData.reps || []);

                setFullname(userData.fname + " " + userData.lname || "");

                // Save user data to localStorage
                localStorage.setItem(`userData_${currentUser.uid}`, JSON.stringify(userData));
            } else {
                console.log('User document not found');
            }

        } catch (error) {
            console.error("Error updating customers", error);
            triggerNotification("accountUpdatedError");
        }
        
        const endTime = Date.now();
        const timeElapsed = (endTime - startTime) /1000;
        setUpdating(false);
        
        triggerNotification("accountUpdated");
        
        if (alertsOn) {
            alert(`Tickets Updated in ${timeElapsed} secs`);
        }
    };

    
    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
    
        setUploading(true);
        try {
            setImage(file); // Store the image in state if needed
    
            // Create a storage reference
            const storageRef = ref(storage, `profileImages/${currentUser.uid}/${file.name}`);
    
            // Upload the image to Firebase Storage
            const snapshot = await uploadBytes(storageRef, file);
    
            // Get the download URL
            const downloadURL = await getDownloadURL(snapshot.ref);
    
            // Save the download URL to Firestore
            await setDoc(doc(db, 'Users', currentUser.uid), {
                profileImageUrl: downloadURL,
            }, { merge: true });
    
            setImageURL(downloadURL); // Update the state with the new image URL
    
            await onUpdate();
            
            if (alertsOn) {
                alert('Profile image uploaded successfully!');
            }
        } catch (error) {
            console.error('Error uploading image:', error);
            if (alertsOn) {
                alert('Error uploading image, please try again.');
            }
        } finally {
            setUploading(false);
        }
    };

    

    const onSubmit = async (e) => {
        e.preventDefault();

        try {
            // Update user data in Firestore collection
            await db.collection('Users').doc(currentUser.uid).update({
                fname: fname,
                lname: lname,
                email: email,
                phone: phone,
                fax: fax,
                
                address: address,
                city: city,
                state: state,
                zip: zip,
                
                region: region,
                accountLevel: accountLevel,
                salesCode: salesCode,
                birthDate: birthDate,
            });
            console.log('User data updated successfully');
            await onUpdate()

            if (alertsOn) {
                alert('User updated successfully');
            }
        } catch (error) {
            console.error("Error updating user data: ", error);
        }
    };

    const [users, setUsers] = useState([]);
    const [selectedReps, setSelectedReps] = useState([]);


    // Fetch users from Firestore on component mount
    useEffect(() => {
        const fetchUsers = async () => {
            const usersCollection = collection(db, 'Users');
            const userSnapshot = await getDocs(usersCollection);
            const userList = userSnapshot.docs.map(doc => ({
                id: doc.id, // UID from Firestore document ID
                name: `${doc.data().fname} ${doc.data().lname}`, // Combining fname and lname into a single name field
                accountLevel: doc.data().accountLevel,
                email: doc.data().email,
                phone:doc.data().phone,
            }));
            setUsers(userList);
        };
        fetchUsers();
    }, []);


    // Handle selection of a user
    const handleSelectChange = (e) => {
        const selectedUserId = e.target.value;
        const selectedUser = users.find(user => user.id === selectedUserId);

        // Add selected user to selectedReps array if not already selected
        if (selectedUser && !selectedReps.some(rep => rep.id === selectedUserId)) {
            setSelectedReps([...selectedReps, selectedUser]);
        }
    };

    // Handle removing a rep from the selectedReps list
    const handleRemoveRep = (repId) => {
        setSelectedReps(selectedReps.filter(rep => rep.id !== repId));
    };

    // Handle the update of the reps array in Firestore
    const handleUpdateReps = async () => {
        try {
            // Update user data in Firestore collection
            await db.collection('Users').doc(currentUser.uid).update({
                reps: selectedReps.map(rep => ({ id: rep.id, name: rep.name })), // Map selected reps to just their IDs
            });
            console.log('User data updated successfully');
            await onUpdate()

            if (alertsOn) {
                alert('User updated successfully');
            }
            
            triggerNotification("repsUpdated");

        } catch (error) {
            console.error("Error updating user data: ", error);
            triggerNotification("repsUpdatedError");
        }
    };
    
    const onSubmitBanner = async (e) => {
        e.preventDefault();

        // Reference to the "banner" document within the "GlobalSettings" collection
        const docRef = db.collection("GlobalSettings").doc("Banner");

        const parsedFormData = {
            title: title,  // Assuming 'title' is state holding the banner title
            body: body,    // Assuming 'body' is state holding the banner body content
            // display: true, // Optional: to control visibility of the banner
            // imageUrl: imageUrl || "", // Optional: image URL if applicable, defaults to empty
        };

        try {
            // Set the banner data in the specified document
            await docRef.set(parsedFormData);

            if (alertsOn) {
                alert("Banner Successfully Updated"); // Optional: alert for user feedback
            }

        } catch (error) {
            console.error("Error updating banner:", error.message);
        }
    };
    
    const handlePasswordReset = async () => {
        const auth = getAuth();
        try {
            await sendPasswordResetEmail(auth, email);
            alert("Password reset email sent! Please check your inbox.");
        } catch (error) {
            alert(`Error: ${error.message}`);
        }
    };
    
    const [newEmail, setNewEmail] = useState("");
    
    const handleEmailUpdate = async (e) => {
        e.preventDefault();
        
        const auth = getAuth();
        const user = auth.currentUser;

        if (!user) {
            if (alertsOn) {
                alert("You need to be logged in to update your email.");
            }
            return;
        }

        try {
            await updateEmail(user, newEmail);
            if (alertsOn) {
                alert("Email address updated successfully!");
            }
        } catch (error) {
            if (alertsOn) {
                alert(`Error: ${error.message}`);
            }
        }
    };

    
    const localStorageKey = 'alertsOn';

    const [alertsOn, setAlertsOn] = useState(() => {
        const storedSettings = localStorage.getItem('alertsOn');
        return storedSettings ? JSON.parse(storedSettings).alertsOn : false; // Default to false if null
    });
    
    // Save settings to local storage when they change
    useEffect(() => {
        localStorage.setItem(
            localStorageKey,
            JSON.stringify({ alertsOn: alertsOn }) // Save as an object
        );
        console.log("Changes Saved");
    }, [alertsOn]);
    

    return (
        <div className={`${darkMode ? 'text-white bg-darkMainColor' : 'text-black bg-white'} flex h-[calc(100dvh-3.5rem)] w-full transition-all duration-500 ease-in-out`}>

            {updating && (
                <Loading/>
            )}
            
            {/*Redesign*/}
            <div className={`w-full flex flex-col h-[calc(100dvh-4rem)] overflow-y-scroll`}>
                
                {/*Header*/}
                <div className={`relative z-30 animate-slideInTop`}>
                    
                    {/*Header*/}
                    <div className={`relative flex justify-between border-b p-4 overflow-hidden ${darkMode ? 'border-neutral-700 bg-white/5' : 'bg-black/80'}`}>
        
                        {/* Background Image */}
                        <img
                            src={course}
                            alt="background"
                            className="absolute inset-0 w-full h-full object-cover opacity-60 z-0"
                        />
                        
                        
                        {/*Profile Img Row + Name*/}
                        <div className={`flex gap-x-3`}>
                            
                            {/*IMG*/}
                            <div className="">
                                <div className="relative overflow-hidden rounded-xl lg:block">
                                    <img alt="" src={profileImage} className={`relative size-32 rounded-xl ${darkMode ? 'border-darkMainColor' : 'border-white'} object-cover`} />
                                    <label
                                        htmlFor="desktop-user-photo"
                                        className="absolute inset-0 flex size-full items-center justify-center bg-green-600/75 text-sm font-medium text-white opacity-0 focus-within:opacity-100 hover:opacity-100"
                                    >
                                        <span>Change</span>
                                        <span className="sr-only"> user photo</span>
                                        <Input
                                            id="desktop-user-photo"
                                            name="user-photo"
                                            type="file"
                                            onChange={handleImageUpload}
                                            accept="image/*"
                                            className="absolute inset-0 size-full cursor-pointer rounded-md border-gray-300 opacity-0"
                                        />
                                    </label>
                                </div>
                            </div>
                            
                            {/*Name + Account Level*/}
                            <div className={` h-fit p-3 rounded-lg text-white backdrop-blur-sm z-50`}>
                                <div className={`flex gap-x-3 items-center`}>
                                    <div className="text-2xl font-semibold">{fullname || "- - - - -"}</div>
                                    <CheckBadgeIcon className={`size-6 text-green-600`}/>
                                </div>
                                <div className="text-sm text-gray-400 italic font-semibold">{email || "- - - - -"}</div>
                                <div className="-mt-1 text-sm italic text-gray-400">{accountLevelMapping[accountLevel] || "- - - - -"}</div>
                            </div>
                            
                        </div>
                        
                        
                        <div className={`z-50`}>
                            <CustomButton
                                onClick={onUpdate}
                                text={`Sync Profile`}
                                icon={ArrowPathIcon}
                                color={`green`}
                            />
                        </div>
                        
                    
                        {/* SVG Overlay */}
                        <EmptySVG />
                    
                    </div>
                    
                    
                </div>
                
                {/*Settings*/}
                <div className={`col-span-3 z-20 animate-fadeIn ${darkMode ? 'bg-darkMainColor border-neutral-700' : 'bg-white'} relative p-3 overflow-y-auto hide-scrollbar transition-all duration-500 ease-in-out`}>
                    
                    {/*Account Info*/}
                    <div className={`w-full space-y-6 p-3 ${darkMode ? 'border-darkBgColor' : ''}`}>
                        
                        {/*Header*/}
                        <div className={`w-full border-b pb-2 ${darkMode ? 'border-neutral-700' : ''}`}>
                            <div className={`text-lg font-bold tracking-widest`}>Account Info</div>
                            <div className={`-mt-1 text-xs text-gray-500 italic`}>Update your account data below | update your profile image above</div>
                        </div>
                        
                        {/*Section*/}
                        <div className={`grid grid-cols-4`}>
                            
                            {/*Section Heading*/}
                            <div className={`col-span-1`}>
                            
                            </div>
                            
                            {/*Form*/}
                            <form onSubmit={onSubmit} method="POST" className={`col-span-3 grid grid-cols-6 gap-x-3 gap-y-8`}>
                                
                                {/*F Name*/}
                                <div className={`relative col-span-3`}>
                                    <label
                                        className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                    >
                                        First Name
                                    </label>
                                    <Input
                                        type="text"
                                        value={fname}
                                        onChange={(e) => setFname(e.target.value)}
                                        placeholder={`First Name`}
                                        className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700  outline' : 'bg-white text-gray-900 outline-gray-300  outline'} px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus: outline focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                    />
                                </div>
                                
                                {/*L Name*/}
                                <div className={`relative col-span-3`}>
                                    <label
                                        className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                    >
                                        Last Name
                                    </label>
                                    <Input
                                        type="text"
                                        required
                                        value={lname}
                                        onChange={(e) => setLname(e.target.value)}
                                        placeholder={`Last Name`}
                                        className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700  outline' : 'bg-white text-gray-900 outline-gray-300  outline'} px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus: outline focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                    />
                                </div>
                                
                                
                                
                                {/*Phone*/}
                                <div className={`relative col-span-3`}>
                                    <label
                                        className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                    >
                                        Phone Number
                                    </label>
                                    <Input
                                        type="text"
                                        value={formatPhoneNumber(phone)}
                                        onChange={(e) => setPhone(e.target.value)}
                                        placeholder={`First Name`}
                                        className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700  outline' : 'bg-white text-gray-900 outline-gray-300  outline'} px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus: outline focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                    />
                                </div>
                                
                                {/*Fax*/}
                                <div className={`relative col-span-3`}>
                                    <label
                                        className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                    >
                                        Fax Number
                                    </label>
                                    <Input
                                        type="text"
                                        required
                                        value={fax}
                                        onChange={(e) => setFax(e.target.value)}
                                        placeholder={`Fax Number`}
                                        className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700  outline' : 'bg-white text-gray-900 outline-gray-300  outline'} px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus: outline focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                    />
                                </div>
        
                                
                                
                                {/*Address*/}
                                <div className={`relative col-span-full`}>
                                    <label
                                        className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                    >
                                        Address
                                    </label>
                                    <Input
                                        type="text"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        placeholder={`Address`}
                                        className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700  outline' : 'bg-white text-gray-900 outline-gray-300  outline'} px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus: outline focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                    />
                                </div>
                                
                                {/*City*/}
                                <div className={`relative col-span-2`}>
                                    <label
                                        className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                    >
                                        City
                                    </label>
                                    <Input
                                        type="text"
                                        value={city}
                                        onChange={(e) => setCity(e.target.value)}
                                        placeholder={`City`}
                                        className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700  outline' : 'bg-white text-gray-900 outline-gray-300  outline'} px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus: outline focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                    />
                                </div>
                               
                                {/*State*/}
                                <div className={`relative col-span-1`}>
                                    
                                    <label
                                        className={`absolute flex z-10 -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                    >
                                        State
                                    </label>
                                    <Select
                                        type="text"
                                        required
                                        value={state}
                                        onChange={(e) => setState(e.target.value)}
                                        className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700  outline' : 'bg-white text-gray-900 outline-gray-300  outline'} px-3 py-2 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus: outline focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                    >
                                        {Object.entries(stateMapping).map(([abbr, name]) => (
                                            <option key={abbr} value={abbr}>
                                              {name}
                                            </option>
                                        ))}
                                    </Select>
                                    
                                </div>
                                
                                {/*Zip*/}
                                <div className={`relative col-span-1`}>
                                    <label
                                        className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                    >
                                        Zip
                                    </label>
                                    <Input
                                        type="text"
                                        value={zip}
                                        onChange={(e) => setZip(e.target.value)}
                                        placeholder={`zip`}
                                        className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700  outline' : 'bg-white text-gray-900 outline-gray-300  outline'} px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus: outline focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                    />
                                </div>
                                
                                
                                {/*Sales Industry*/}
                                <div className={`relative col-span-2`}>
                                    <label
                                        className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                    >
                                        Sales Industry
                                    </label>
                                    <Select
                                        type="text"
                                        required
                                        value={region}
                                        onChange={(e) => setRegion(e.target.value)}
                                        className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700  outline' : 'bg-white text-gray-900 outline-gray-300  outline'} px-3 py-2 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus: outline focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                    >
                                        <option value="AG">Agriculture</option>
                                        <option value="DIST1">Distributor</option>
                                        <option value="DIST2">Distributor 2</option>
                                        <option value="NE">Northeast</option>
                                        <option value="SE">Southeast</option>
                                    </Select>
                                </div>
                                
                                
                                
                                {/*Account Level*/}
                                <div className={`relative col-span-2`}>
                                    <label
                                        className={`absolute flex z-10 -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                    >
                                        Account Level
                                    </label>
                                    <Select
                                        type="text"
                                        required
                                        value={accountLevel}
                                        disabled={true}
                                        onChange={(e) => setAccountLevel(e.target.value)}
                                        className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700  outline' : 'bg-white text-gray-900 outline-gray-300  outline'} px-3 py-2 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus: outline focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                    >
                                        <option value="S">Salesperson</option>
                                        <option value="CSR">CSR (Customer Service Rep)</option>
                                        <option value="PFC">PFC Fulfillment</option>
                                        <option value="DIST">Distributor</option>
                                        <option value="A">Admin</option>
                                        <option value="D">Developer</option>
                                    
                                    </Select>
                                </div>
                                
                                {/*Sales Code*/}
                                <div className={`relative col-span-2`}>
                                    <label
                                        className={`absolute flex z-10 -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                    >
                                        Sales Code
                                    </label>
                                    <Input
                                        type="text"
                                        value={salesCode}
                                        disabled={true}
                                        onChange={(e) => setSalesCode(e.target.value)}
                                        placeholder={`Sales Code`}
                                        className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700  outline' : 'bg-white text-gray-900 outline-gray-300  outline'} px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus: outline focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                    />
                                </div>
                                
                                {/*Supervisor*/}
                                <div className={`relative col-span-2`}>
                                    <label
                                        className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                    >
                                        Supervisor
                                    </label>
                                    <Input
                                        type="text"
                                        value={supervisorMapping[supervisor]}
                                        disabled={true}
                                        onChange={(e) => setSupervisor(e.target.value)}
                                        placeholder={`Address`}
                                        className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700  outline' : 'bg-white text-gray-900 outline-gray-300  outline'} px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus: outline focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                    />
                                </div>
                                
                                
                                
                                {/*Email Address*/}
                                <div className={`relative col-span-4`}>
                                    <label
                                        className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                    >
                                        Email Address
                                    </label>
                                    <Input
                                        type="text"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder={`Email Address`}
                                        className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700  outline' : 'bg-white text-gray-900 outline-gray-300  outline'} px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus: outline focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                    />
                                </div>
                                
                                {/*BirthDay*/}
                                <div className={`relative col-span-2`}>
                                    <label
                                        className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                    >
                                        Birthday
                                    </label>
                                    <Input
                                        type="date"
                                        disabled={false}
                                        value={birthDate}
                                        onChange={(e) => setBirthDate(e.target.value)}
                                        placeholder={`Email Address`}
                                        className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700  outline' : 'bg-white text-gray-900 outline-gray-300  outline'} px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus: outline focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                    />
                                </div>
                                
                                
        
                                {/*Save Button*/}
                                <div className={`col-span-full`}>
                                    <Button
                                        type="submit"
                                        // disabled={isRegistering}
                                        className="flex w-1/4 ml-auto hover:scale-105 justify-center rounded-md bg-green-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-green-600/50"
                                    >
                                        Update Account
                                    </Button>
                                </div>
                                
                            </form>

                        </div>
                        
                    </div>
    
                    {/*General*/}
                    <div className={`w-full  p-3 ${darkMode ? 'border-darkBgColor' : ''}`}>
                        
                        <div className={`w-full border-b pb-2 ${darkMode ? 'border-neutral-700' : ''}`}>
                            <div className={`text-lg font-bold tracking-widest`}>General Account Settings</div>
                            <div className={`-mt-1 text-xs text-gray-500 italic`}>These are general settings for your account</div>
                        </div>
                        
                        <div className={`grid grid-cols-4`}>
                            
                            {/*Section Heading*/}
                            <div className={`col-span-1`}>
                            
                            </div>
                            
                            {/*Form*/}
                            <div className={`col-span-3 space-y-6 py-5`}>
                                
                                {/*DarkMode*/}
                                <div className="w-full flex flex-row items-center">
        
                                    <label htmlFor="email" className="block w-1/4 text-sm font-medium leading-6 ">
                                        Dark Mode:
                                    </label>
        
                                    {/*ToggleSwitch*/}
                                    <div className="w-fit ml-10">
                                        <input
                                            type="checkbox"
                                            id="spray"
                                            name="spray"
                                            checked={darkMode}
                                            onChange={toggleDarkMode} // Call the toggle function from context
                                            className="sr-only w-fit"
                                        />
                                        <label htmlFor="spray" className="cursor-pointer">
                                            <div
                                                className={`mr-auto ml-auto w-14 h-8 rounded-full relative ${darkMode ? 'bg-darkBgColor' : 'bg-bgColor drop-shadow shadow-gray-900'}`}>
                                                <div
                                                    className={`dot absolute left-1 top-1 w-6 h-6 rounded-full transition-transform duration-300 ${darkMode ? 'bg-darkMainColor translate-x-full' : 'bg-white'}`}>
                                                    {darkMode ? (
                                                        <MoonIcon
                                                            className="w-4 h-full flex-none text-gray-300 mr-auto ml-auto mt-auto mb-auto"
                                                            aria-hidden="true"
                                                        />
                                                    ) : (
                                                        <SunIcon
                                                            className="w-4 h-full flex-none text-black mr-auto ml-auto mt-auto mb-auto"
                                                            aria-hidden="true"
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </label>
                                    </div>
        
        
                                </div>
        
                                {/*Reset Password*/}
                                <div className="w-full flex flex-row items-center">
        
                                    <label htmlFor="email" className="block w-1/4 text-sm font-medium leading-6 ">
                                        Password Reset:
                                    </label>
        
                                    {/*Button*/}
                                    <div className="w-1/4 ml-10">
        
                                        <Button
                                            onClick={togglePassword}
                                            className="flex w-full hover:scale-105 ml-auto justify-center rounded-md bg-green-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-green-600/50"
                                        >
                                            Reset Password
                                        </Button>
        
                                    </div>
        
        
                                </div>
        
                                {/*Reset Email*/}
                                <div className="w-full flex flex-row items-center">
        
                                    <label htmlFor="email" className="block w-1/4 text-sm font-medium leading-6 ">
                                        Email Reset:
                                    </label>
        
                                    {/*Button*/}
                                    <div className="w-1/4 ml-10">
        
                                        <Button
                                            onClick={toggleEmail}
                                            className="flex ml-auto hover:scale-105 w-full justify-center rounded-md bg-green-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-green-600/50"
                                        >
                                            Reset Email
                                        </Button>
        
                                    </div>
        
        
                                </div>
        
                                {/*Alerts*/}
                                <div className="w-full flex flex-row items-center">
        
                                    <label className="block w-1/4 text-sm font-medium leading-6 ">
                                        Alerts:
                                    </label>
        
                                    {/*ToggleSwitch*/}
                                    <Field className="flex w-fit ml-10 col-span-2">
                                        <Switch
                                            checked={alertsOn}
                                            onChange={setAlertsOn}
                                            className="group relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full bg-transparent"
                                        >
                                            <span className="sr-only">Use setting</span>
                                            <span aria-hidden="true"
                                                  className="pointer-events-none absolute size-full rounded-md"/>
                                            <span
                                                aria-hidden="true"
                                                className={`pointer-events-none absolute mx-auto h-4 w-9 rounded-full ${darkMode ? 'bg-neutral-700' : 'bg-gray-200'} transition-colors duration-200 ease-in-out group-data-[checked]:bg-green-600`}
                                            />
                                            <span
                                                aria-hidden="true"
                                                className="pointer-events-none absolute left-0 inline-block size-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                            />
                                        </Switch>
                                        <Label as="span" className="ml-3 text-sm w-full">
                                            <span className="font-medium">Alert Windows</span>{' '}
                                            <span className="text-gray-500 text-xs">(Popup Windows after every action)</span>
                                        </Label>
                                    </Field>
        
        
                                </div>
                                
                                {/*Notifications*/}
                                <div className="w-full flex flex-row items-center">
        
                                    <label className="block w-1/4 text-sm font-medium leading-6 ">
                                        Notifications:
                                    </label>
        
                                    {/*ToggleSwitch*/}
                                    <Field className="flex w-fit ml-10 col-span-2">
                                        <Switch
                                            checked={notificationsEnabled}
                                            onChange={toggleNotifications}
                                            className="group relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full bg-transparent"
                                        >
                                            <span className="sr-only">Use setting</span>
                                            <span aria-hidden="true"
                                                  className="pointer-events-none absolute size-full rounded-md"/>
                                            <span
                                                aria-hidden="true"
                                                className={`pointer-events-none absolute mx-auto h-4 w-9 rounded-full ${darkMode ? 'bg-neutral-700' : 'bg-gray-200'} transition-colors duration-200 ease-in-out group-data-[checked]:bg-green-600`}
                                            />
                                            <span
                                                aria-hidden="true"
                                                className="pointer-events-none absolute left-0 inline-block size-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                            />
                                        </Switch>
                                        <Label as="span" className="ml-3 text-sm w-full">
                                            <span className="font-medium">Notifications</span>{' '}
                                            <span className="text-gray-500 text-xs">(Notification in top right of screen)</span>
                                        </Label>
                                    </Field>
        
        
                                </div>
                                
                            </div>
                            
                        </div>
    
                    </div>
                    
                    {/*CSR*/}
                    {["D", "A", "CSR", "PFC"].includes(accountLevel) && (
                        <>
    
                            {/*CSR*/}
                            <div className={`w-full p-3 ${darkMode ? 'border-darkBgColor' : ''}`}>
                                
                                {/*Header*/}
                                <div className={`w-full border-b pb-2 ${darkMode ? 'border-neutral-700' : ''}`}>
                                    <div className={`text-lg font-bold tracking-widest`}>Sales Reps List</div>
                                    <div className={`-mt-1 text-xs text-gray-500 italic`}>Update your reps list within your account below to fit your SalesReps</div>
                                </div>
                                
                                <div className={`grid grid-cols-4`}>
                                    
                                    <div className={`col-span-1`}>
                                    
                                    </div>
                                    
                                    <form method="POST" className={`col-span-3 space-y-6 p-3`}>
                                        
                                        
                                        <div className="">
                                            
                                            {/*Select*/}
                                            <div className={`relative`}>
                                                <label
                                                    className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                                >
                                                    Sales Rep
                                                </label>
                                                <Select
                                                    type="text"
                                                    onChange={handleSelectChange}
                                                    className={`block w-1/2 rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700  outline' : 'bg-white text-gray-900 outline-gray-300  outline'} px-3 py-2 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus: outline focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                                >
                                                    <option value="">Select a Sales Rep</option>
                                                    {users
                                                      .filter(user => user.accountLevel === "S" || user.accountLevel === "A" || user.accountLevel ==="DIST")
                                                      .map(user => (
                                                        <option key={user.id} value={user.id}>
                                                          {user.name}
                                                        </option>
                                                      ))}
                                                </Select>
                                            </div>
                                            
                                            {/* Display selected reps */}
                                            <div className="mt-2 min-h-64">
                                                <h3 className="font-medium text-gray-500 italic text-sm">Selected Reps:</h3>
                                                
                                                
                                                {selectedReps.length === 0 ? (
                                                    // Display custom dialog if sprays array is empty
                                                    <div className="flex w-full h-full justify-center items-center py-10">
                                                        
                                                        <div className={`flex items-center  border border-dashed ${darkMode ? 'text-white border-borderColor' : 'text-black bg-neutral-50'} w-fit px-4 py-1 h-fit mr-auto ml-auto justify-center rounded-lg hover:scale-105`}>
                                                            <div className="p-2 rounded-md shadow-gray-900 flex items-center justify-center flex-col m-2">
                                                                <EyeSlashIcon className={`w-10 stroke-2 mr-3`}/>
                                                                <p className="text-md mt-2 line-clamp-1 tracking-widest flex">You Have No Reps Selected</p>
                                                                <p className="text-sm mt-2 line-clamp-1 tracking-widest flex text-gray-500">You may select your reps from the dropdown above</p>
                                                            </div>
                                                        </div>
                                                    
                                                    </div>
                                                ) : (
                                                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3">
                                                        {selectedReps.map((rep, index) => (
                                                            <div key={index} className={`flex w-full items-center py-1.5 border-b hover:opacity-50 ${darkMode ? 'border-neutral-700' : ''}`}>
                                                                
                                                                <span className="mr-2 text-sm">{rep.name}</span>
                                                                
                                                                <Button
                                                                    onClick={() => handleRemoveRep(rep.id)}
                                                                    className="text-red-500 hover:text-red-700 ml-auto"
                                                                >
                                                                    <XMarkIcon
                                                                        className="h-5 text hover:text-red-500 hover:animate-pulse hover:scale-110 m-auto"/>
                                                                </Button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                
                                                )}
                                                
                                                {/*{selectedReps.map((rep, index) => (*/}
                                                {/*    <div key={index}*/}
                                                {/*         className={`flex hover:scale-105 w-full animate-zoomIn items-center py-1.5 ${darkMode ? 'bg-darkBgColor' : 'bg-bgColor shadow'} bg-opacity-50 mb-2 rounded-lg px-2`}>*/}
                                                
                                                {/*        <span*/}
                                                {/*            className="mr-2 text-gray-500 text-sm">{rep.name}</span>*/}
                                                
                                                {/*        <Button*/}
                                                {/*            onClick={() => handleRemoveRep(rep.id)}*/}
                                                {/*            className="text-red-500 hover:text-red-700 ml-auto"*/}
                                                {/*        >*/}
                                                {/*            <XMarkIcon className="h-5 text hover:text-red-500 hover:animate-pulse hover:scale-110 m-auto"/>*/}
                                                {/*        </Button>*/}
                                                
                                                {/*    </div>*/}
                                                {/*))}*/}
                                            
                                            
                                            </div>
                                        
                                        
                                        </div>
                                        
                                        
                                        <div className={`w-full items-center flex justify-end`}>
                                            <Button
                                                onClick={handleUpdateReps}
                                                className="flex w-1/4 ml-auto hover:scale-105 justify-center rounded-md bg-green-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-green-600/50"
                                            >
                                                Update Reps List
                                            </Button>
                                        </div>
                                    </form>
                                    
                                </div>
                            
                            </div>
                        
                        </>
                    )}
                    
                    {["D",].includes(accountLevel) && (
                        <>
                            
                            {/*Banner Settings*/}
                            <div className={`hidden w-full p-3 ${darkMode ? 'border-darkBgColor' : ''}`}>
                                <div className={`text-lg font-bold tracking-widest`}>Home Page Banner</div>
                                <div className={`text-xs ml-3 text-gray-500 mb-3`}>Below you can update the banner that appears on the home screen for every user.</div>
    
                                <form
                                    onSubmit={onSubmitBanner}
                                    method="POST"
                                    className={`space-y-4 grid grid-cols-2 p-3 mb-2  border rounded-lg ${darkMode ? 'border-darkBgColor' : ''}`}>
    
                                     {/*Title*/}
                                    <div className={`relative col-span-1`}>
                                        <label
                                            className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                        >
                                            Banner Title
                                        </label>
                                        <Input
                                            type="text"
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                            placeholder={`Type Banner Title`}
                                            className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700  outline' : 'bg-white text-gray-900 outline-gray-300  outline'} px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus: outline focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                        />
                                    </div>
                                    
                                    {/*Body*/}
                                    <div className={`relative col-span-2`}>
                                        <label
                                            className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                        >
                                            Banner Body
                                        </label>
                                        <Textarea
                                            value={body}
                                            onChange={(e) => setBody(e.target.value)}
                                            placeholder={`Type out the body of the banner here`}
                                            className={`block w-full h-36 max-h-64 rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700  outline' : 'bg-white text-gray-900 outline-gray-300  outline'} px-3 py-2 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus: outline focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                        />
                                    </div>
                                    
                                    {/*Button*/}
                                    <div className={`col-span-full`}>
                                        <Button
                                            type="submit"
                                            // disabled={isRegistering}
                                            className="flex w-1/4 ml-auto hover:scale-105 justify-center rounded-md bg-green-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-green-600 focus-visible:outline focus-visible: outline focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                        >
                                            Update Banner
                                        </Button>
                                    </div>
                                </form>
    
                            </div>
    
                        </>
                    )}
                    
                    {["D"].includes(accountLevel) && (
                        <>
    
                            {/*User Account Levels*/}
                            <div className={`w-full p-3 ${darkMode ? 'border-darkBgColor' : ''}`}>
                                
                                <div className={`w-full border-b pb-2 ${darkMode ? 'border-neutral-700' : ''}`}>
                                    <div className={`text-lg font-bold tracking-widest`}>User Account Levels [{users.length || 0}]</div>
                                    <div className={`-mt-1 text-xs text-gray-500 italic`}>Update user account levels to give or restrict their access to certain features</div>
                                </div>
                                
                                
                                <div className={`grid grid-cols-4`}>
                                    
                                    <div className={`col-span-1`}>
                                    
                                    </div>
    
                                    {/* Display selected reps */}
                                    <div className="col-span-3 p-3 overflow-y-scroll scrollbar-hide">
                                        
                                        {users.length === 0 ? (
                                            // Display custom dialog if sprays array is empty
                                            <div className="flex w-full h-full justify-center items-center py-10">
    
                                                <div className={`flex items-center  border border-dashed ${darkMode ? 'text-white border-borderColor' : 'text-black bg-neutral-50'} w-fit px-4 py-1 h-fit mr-auto ml-auto justify-center rounded-lg hover:scale-105`}>
                                                    <div className="p-2 rounded-md shadow-gray-900 flex items-center justify-center flex-col m-2">
                                                        <EyeSlashIcon className={`w-10 stroke-2 mr-3`}/>
                                                        <p className="text-md mt-2 line-clamp-1 tracking-widest flex">You Have No Reps Selected</p>
                                                        <p className="text-sm mt-2 line-clamp-1 tracking-widest flex text-gray-500">You may select your reps from the dropdown above</p>
                                                    </div>
                                                </div>
    
                                            </div>
                                        ) : (
                                            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                                                {users.map((person, index) => (
                                                    <AccountCard person={person}/>
                                                ))}
                                            </div>
                                        
                                        )}
                                    
                                    </div>
                                
                                
                                </div>
                            
                            </div>
                        
                        </>
                    )}
                
                </div>
                
            </div>
            
            
            <Dialog open={isPassword} onClose={setIsPassword} className="relative z-50">
              <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500/50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
              />
        
              <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <DialogPanel
                    transition
                    className={`relative transform overflow-hidden rounded-lg ${darkMode ? 'bg-darkMainColor text-white' : 'bg-white text-black'} px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                  >
                    <div className="sm:flex sm:items-start">
                      <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-green-600/15 sm:mx-0 sm:size-10">
                        <LockOpenIcon aria-hidden="true" className="size-6 text-green-600" />
                      </div>
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <DialogTitle as="h3" className="text-base font-semibold">
                          Password Reset
                        </DialogTitle>
                        <div className="mt-2">
                          <p className="text-sm text-gray-500">
                            For security purposes, we can send a password reset link to the email
                              associated with your account. If you don’t see the email right away,
                              please check your spam or junk folder.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                      <Button
                        type="button"
                        onClick={handlePasswordReset}
                        className={`inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 sm:ml-3 sm:w-auto`}
                      >
                        Send Reset Link
                      </Button>
                      <Button
                        type="button"
                        data-autofocus
                        onClick={togglePassword}
                        className={`mt-3 inline-flex w-full justify-center rounded-md ${darkMode ? 'bg-darkBgColor' : 'bg-white ring-1 ring-inset ring-gray-300'} px-3 py-2 text-sm font-semibold shadow-sm hover:bg-opacity-50 sm:mt-0 sm:w-auto`}
                      >
                        Cancel
                      </Button>
                    </div>
                  </DialogPanel>
                </div>
              </div>
            </Dialog>

            <Dialog open={isEmail} onClose={toggleEmail} className="relative z-50">
              <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500/50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
              />
        
              <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <DialogPanel
                    transition
                    className={`relative transform overflow-hidden rounded-lg ${darkMode ? 'bg-darkMainColor text-white' : 'bg-white text-black'} px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                  >
                    <div className="sm:flex sm:items-start">
                      <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-green-600/15 sm:mx-0 sm:size-10">
                        <EnvelopeIcon aria-hidden="true" className="size-6 text-green-600" />
                      </div>
                        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                            <DialogTitle as="h3" className="text-base font-semibold">
                                Email Reset
                            </DialogTitle>
                            <div className="mt-2 w-full">
                                <p className="text-sm text-gray-500 w-full">
                                    This will reset the email associated with your account. This email should be an @plantfoodco.com email.
                                </p>
                            </div>
                            
                            <form className="grid grid-cols-2 gap-y-4 gap-x-3 mt-6"
                                  onSubmit={handleEmailUpdate}
                                  method="POST">
                                
                                {/*Notes*/}
                                <div className={`relative col-span-2`}>
                                    <label
                                        className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                    >
                                        New Email
                                    </label>
                                    <Input
                                        value={newEmail}
                                        required
                                        onChange={(e) => setNewEmail(e.target.value)}
                                        placeholder={`Type New Email`}
                                        className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700  outline' : 'bg-white text-gray-900 outline-gray-300  outline'} px-3 py-2 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus: outline focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                    />
                                </div>
                                
                                {/*Buttons*/}
                                <div className="col-span-full mt-4 sm:flex sm:flex-row-reverse">
                                    <Button
                                        type="submit"
                                        // onClick={handleEmailUpdate}
                                        // disabled={!selectedCustomer}
                                        className={` inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 sm:ml-3 sm:w-auto`}
                                    >
                                        Reset Email
                                    </Button>
                                    <Button
                                        type="button"
                                        data-autofocus
                                        onClick={toggleEmail}
                                        className={`mt-3 inline-flex w-full justify-center rounded-md ${darkMode ? 'bg-darkBgColor' : 'bg-white ring-1 ring-inset ring-gray-300'} px-3 py-2 text-sm font-semibold shadow-sm hover:bg-opacity-50 sm:mt-0 sm:w-auto`}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            
                            
                            </form>
                        
                        
                        </div>
                    </div>
                  </DialogPanel>
                </div>
              </div>
            </Dialog>
        
        </div>
    )
};


export default Profile;
